import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
//Material Imports
import { withStyles } from "@material-ui/core/styles"; //Limitless imports

import SubmitButton from "../../forms/submit-button/SubmitButton";

var NewMessageFooter = /*#__PURE__*/function (_PureComponent) {
  _inherits(NewMessageFooter, _PureComponent);

  var _super = _createSuper(NewMessageFooter);

  function NewMessageFooter() {
    _classCallCheck(this, NewMessageFooter);

    return _super.apply(this, arguments);
  }

  _createClass(NewMessageFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          onButtonClick = _this$props.onButtonClick;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.container
      }, /*#__PURE__*/React.createElement(SubmitButton, {
        disabled: false,
        id: "newConversationButton",
        title: "New Conversation",
        handleSubmit: onButtonClick,
        loading: false,
        containerEnabled: false,
        staticButton: true
      }));
    }
  }]);

  return NewMessageFooter;
}(PureComponent);

var styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 -2px 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.06)",
    minHeight: 55
  }
};
export default withStyles(styles)(NewMessageFooter);